/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons/index.js";
import AmountToWords from "../../../../components/_utils/AmountToWords.js";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup/index.jsx";
import ScheduleTransactionStepAdditionalDetails from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionCreate/ScheduleTransactionStepAdditionalDetails";
import ScheduleTransactionStepAmount from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionCreate/ScheduleTransactionStepAmount";
import ScheduleTransactionStepConfirm from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionCreate/ScheduleTransactionStepConfirm";
import ScheduleTransactionStepFrequency from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionCreate/ScheduleTransactionStepFrequency";
import ScheduleTransactionStepSelectAccount from "../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionCreate/ScheduleTransactionStepSelectAccount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  getAllCategories,
  uploadFile,
} from "../../../../redux/features/sharedResources/sharedResources";
import {
  scheduledBeneficiaryCreate,
  scheduledBeneficiaryOccurrences,
} from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaymentMethodAnimationConfiguration,
} from "../../../../utils/configurationProvider";
import { SLOT_DATA } from "../../../../utils/dateConstants.js";
import globalText from "../../../../utils/globalText";
import Validation from "../../../../utils/validation.js";

const RTGS_MIN_AMOUNT = 200000;

const ScheduleBeneficiaryTransactionCreate = () => {
  const steps = [
    globalText?.SOURCE_AND_DESTINATION_ACCOUNT,
    globalText?.CATEGORY_AND_LABELS,
    globalText?.AMOUNT,
    globalText?.FREQUENCY,
    globalText?.CONFIRM_AND_CREATE,
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dateRef = useRef(null);
  const dropdownRef = useRef();
  const endDateRef = useRef(null);
  const slotdropdownRef = useRef();
  const yearDropdownRef = useRef(null);
  const currentAccountDetails = location?.state;
  const [endDate, setEndDate] = useState({});
  const [isNeft, setIsNeft] = useState(true);
  const [isRtgs, setIsRtgs] = useState(false);
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [hyperLink, setHyperLink] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [quantities, setQuantities] = useState([]);
  const [direction, setDirection] = useState(null);
  const [remAccount, setRemAccount] = useState("");
  const [openOwner, setOpenOwner] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [additionalData, setAdditionalData] = useState({});
  const [isConfidential, setIsConfidential] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [slotdropdownOpen, setSlotDropdownOpen] = useState(false);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [transactionDisable, setTransactionDisable] = useState(false);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [SlotMappingData, setSlotMappingData] = useState(SLOT_DATA || []);
  const [openOccurrencesModal, setOpenOccurrencesModal] = useState(false);
  const [showConfirmLeavePopup, setShowConfirmLeavePopup] = useState(false);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);
  const [txnPayLoad, setTxnPayLoad] = useState({
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    beneAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : null,
    bankAccountName: currentAccountDetails?.bank_account_holder_full_name
      ? currentAccountDetails.bank_account_holder_full_name
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",
    scheduleName: "",
    categoryIds: currentAccountDetails?.category
      ? currentAccountDetails?.category
      : "",
    amount: "",
    amountInWords: "",
    settleType: "",
    ownerId: null,
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerLastUpdated: null,
    ownerBankLogo: null,
    ownerBankAccountNo: null,
    ownerBankAccountName: null,
    selectedCategory: null,
    mergeCategory: null,
    destinationAccountBalance: null,
    destinationAcountOwnerId: null,
    isDestinationOwnerActive: null,
    destinationAcountOwnerLastUpdated: null,
    frequency: "",
    transaction_start_date: "",
    transaction_end_date: "",
    slot: "",
    occurrencesCount: "",
    labels: currentAccountDetails?.labels ? currentAccountDetails?.labels : [],
    ownerLabels: [],
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categoryIds ? txnPayLoad?.categoryIds?.split(",") : [],
  );

  const parseToDateOrNull = (d) => {
    if (!d) return null;
    const candidate = new Date(d);
    return isNaN(candidate) ? null : candidate;
  };

  const [frequencyStartDate, setFrequencyStartDate] = useState(
    parseToDateOrNull(txnPayLoad?.transaction_start_date),
  );

  const [frequencyEndDate, setFrequencyEndDate] = useState(
    parseToDateOrNull(txnPayLoad?.transaction_end_date),
  );

  const labelActionDispatchedRef = useRef(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  const monthsFullName = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleUnassignNavigate = (id) => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_categories/${id}`,
      { replace: false },
    );
  };

  const handleInputChange = (e) => {
    if (e?.preventDefault) e.preventDefault();

    const {
      name,
      value,
      data_type: dataType,
    } = e.target || {
      name: e.name,
      value: e.value,
      data_type: e.data_typeChan,
    };

    const field = txnPayLoad?.selectedCategory?.configuration?.data?.find(
      (item) => item.name === name,
    );

    if (!field) return;

    let updatedData = { ...additionalData };

    const type = dataType || field.data_type;

    switch (type) {
      case "month_year": {
        if (value?.month && value?.year) {
          const monthNumber = (
            monthsFullName.indexOf(value.month) +
            GlobalConfiguration.lengthCheckOne
          )
            .toString()
            .padStart(2, "0");

          updatedData[name] = `${monthNumber}/${value.year}`;
        } else {
          updatedData[name] = "";
        }
        break;
      }

      case "from_year_to_year":
        updatedData[name] = {
          from:
            value?.from !== "" && value?.from !== undefined
              ? Number(value.from)
              : null,
          to:
            value?.to !== "" && value?.to !== undefined
              ? Number(value.to)
              : null,
        };
        break;

      case "date_range":
        updatedData[name] =
          value?.start_date && value?.end_date
            ? {
                start_date: value.start_date,
                end_date: value.end_date,
              }
            : null;
        break;

      case "numeric":
        if (value === "") {
          updatedData[name] = "";
        } else {
          const cleaned = String(value).replace(/\D/g, "").slice(0, 15);

          updatedData[name] = Number(cleaned);
        }
        break;

      case "quantity":
        updatedData[name] = Number(value);
        break;

      default:
        updatedData[name] =
          typeof value === "string" ? value.replace(/^\s+/, "") : value;
        break;
    }

    setAdditionalData(updatedData);
  };

  const handleClose = (finalLabels) => {
    setShowLabelModal(false);
    if (!finalLabels) return;

    const currentOwnerLabels = txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = finalLabels?.filter((label) =>
      currentOwnerLabels?.includes(label),
    );
    const newOtherLabels = finalLabels?.filter(
      (label) => !currentOwnerLabels?.includes(label),
    );

    setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerLabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };

  const handleCategorySelect = (categoryId) => {
    const categoryData = categories?.find((c) => c.id === categoryId);
    const isAssigned = category?.includes(categoryId);

    if (!categoryData || categoryData?.active !== "Y" || !isAssigned) {
      setSelectedCategory(null);
      setTxnPayLoad((prev) => ({
        ...prev,
        selectedCategory: null,
        mergeCategory: null,
      }));
      setAdditionalData({});
      return;
    }

    setIsCategoryLoading(true);
    setSelectedCategory(categoryData);
    setTxnPayLoad((prev) => ({
      ...prev,
      selectedCategory: categoryData,
      mergeCategory: categoryData?.configuration?.data || [],
    }));

    setAdditionalData({});
    setSelectedValue({ from: "Select", to: "Select" });
    setStartDate({});
    setEndDate({});
    setHyperLink({});
    setPreviewImages({});
    setUploadedFiles({});
    setTimeData({});
    setQuantities({});
    setSelectedValueMonth({});
    setIsCategoryLoading(false);
  };

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const frequencyOptions = [
    "Once",
    "Daily",
    "Weekly",
    "Fortnightly",
    "Monthly",
    "Quarterly",
    "Half yearly",
    "Yearly",
  ];

  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const unassignCategories = categories;

  const [disableCategories] = useState(true);

  const unassignlength = unassignCategories?.filter(
    (unassignCategory) => !category?.includes(unassignCategory?.id),
  );

  const isCategorySelected = !!selectedCategory;
  const allLabels = [
    ...new Set([
      ...(txnPayLoad?.ownerLabels || []),
      ...(txnPayLoad?.labels || []),
    ]),
  ];

  const handleCreateTransaction = async () => {
    if (transactionDisable) return;
    setTransactionDisable(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not given";
    });

    let storeData;
    let add = 0;

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadFile({ file: file })),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              return {
                ...val,
                value: Number(dataValue),
              };
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            return {
              ...val,
              value: Number(dataValue),
            };
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const txnData = {
      amount: txnPayLoad.amount,
      owner_account_id: txnPayLoad.ownerId,
      beneficiary_account_id: txnPayLoad.beneAccountId,
      category_id: selectedCategory?.id,
      payment_method: txnPayLoad.settleType.toUpperCase(),
      scheduled_name: txnPayLoad.scheduleName,
      frequency:
        txnPayLoad?.frequency === "Half yearly"
          ? "half_yearly"
          : txnPayLoad.frequency.toLowerCase(),
      occurrences: txnPayLoad.occurrences,
      confidential_transaction: isConfidential,
      transaction_start_date: txnPayLoad.transaction_start_date,
      transaction_end_date: txnPayLoad.transaction_end_date,
      slot: txnPayLoad.slot,
      additional_data: {
        data: storeData,
      },
      type_of_transactions: "Beneficiary Transaction",
      labels: [...(txnPayLoad.labels || []), ...(txnPayLoad.ownerLabels || [])],
    };

    const response = await dispatch(
      scheduledBeneficiaryCreate({
        scheduledBeneficiaryTxnData: txnData,
      }),
    );

    if (scheduledBeneficiaryCreate.fulfilled.match(response)) {
      const transactionId = response.payload?.transaction?.[0]?.txn_id;

      navigate(
        `/beneficiary_transaction_dashboard/create_schedule/success/${transactionId}`,
      );

      setTransactionDisable(false);
      return;
    }

    sessionStorage.setItem(
      "schedule_txn_error",
      JSON.stringify(response.payload),
    );

    navigate("/beneficiary_transaction_dashboard/create_schedule/failed");

    setTransactionDisable(false);
  };

  const handleNext = () => {
    if (activeStep < 4) {
      setActiveStep((prevActiveStep) =>
        prevActiveStep < 4 ? prevActiveStep + 1 : 4,
      );
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
    } else {
      handleCreateTransaction();
    }
  };

  const isFormDirty = () => {
    const initialBeneAccountId = currentAccountDetails?.id || null;
    const initialCategory = currentAccountDetails?.category || "";

    return (
      txnPayLoad.ownerId !== null ||
      txnPayLoad.beneAccountId !== initialBeneAccountId ||
      txnPayLoad.categoryIds !== initialCategory ||
      txnPayLoad.scheduleName !== ""
    );
  };

  const handleBack = () => {
    if (activeStep === 0) {
      if (isFormDirty()) {
        setShowConfirmLeavePopup(true);
      } else {
        navigate(-1);
      }
      return;
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep ? prevActiveStep - 1 : 0,
      );
      setDirection("previous");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
    }
  };

  const commonStepConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((step, index) => {
    const isLastStep = index === steps.length - 1;
    const isTxnLoading = isLastStep && transactionDisable;

    return {
      ...commonStepConfig,
      previousText: index === 0 ? "Cancel" : "Previous",
      nextText: isLastStep ? "Create" : "Next",
      nextEnableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isTxnLoading
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep ? !transactionDisable : isNextButtonEnabled,
      stepperText: step,
    };
  });

  const renderBillerForms = () => {
    switch (activeStep) {
      case 0:
        return (
          <ScheduleTransactionStepSelectAccount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            activeType={activeType}
            setActiveType={setActiveType}
            setRemPan={setRemPan}
            setRemAccount={setRemAccount}
            setRemIFSC={setRemIFSC}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            handleOwnerSelection={handleOwnerSelection}
            handleAccountSelection={handleAccountSelection}
          />
        );
      case 1:
        return (
          <ScheduleTransactionStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            beneAccountId={txnPayLoad?.beneAccountId}
            category={category}
            selectedCategory={selectedCategory}
            unassignCategories={unassignCategories}
            unassignlength={unassignlength}
            disableCategories={disableCategories}
            isCategoryLoading={isCategoryLoading}
            isCategorySelected={isCategorySelected}
            handleCategorySelect={handleCategorySelect}
            handleUnassignNavigate={handleUnassignNavigate}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            handleInputChange={handleInputChange}
            hyperLink={hyperLink}
            setHyperLink={setHyperLink}
            timeData={timeData}
            setTimeData={setTimeData}
            quantities={quantities}
            setQuantities={setQuantities}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            selectedLabelsCreate={selectedLabelsCreate}
            setShowLabelModal={setShowLabelModal}
          />
        );
      case 2:
        return (
          <ScheduleTransactionStepAmount
            txnPayLoad={txnPayLoad}
            isNeft={isNeft}
            isRtgs={isRtgs}
            slideAnimation={slideAnimation}
            handleAmountChange={handleAmountChange}
            handleNeftClick={handleNeftClick}
            handleRtgsClick={handleRtgsClick}
          />
        );
      case 3:
        return (
          <ScheduleTransactionStepFrequency
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setOpenOccurrencesModal={setOpenOccurrencesModal}
            SlotMappingData={SlotMappingData}
            frequencyOptions={frequencyOptions}
            frequencyStartDate={frequencyStartDate}
            frequencyEndDate={frequencyEndDate}
            setFrequencyStartDate={setFrequencyStartDate}
            setFrequencyEndDate={setFrequencyEndDate}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            showEndDatePicker={showEndDatePicker}
            setShowEndDatePicker={setShowEndDatePicker}
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
            slotdropdownOpen={slotdropdownOpen}
            setSlotDropdownOpen={setSlotDropdownOpen}
            dateRef={dateRef}
            endDateRef={endDateRef}
            yearDropdownRef={yearDropdownRef}
            formatDate={formatDate}
            handleDateChange={handleDateChange}
            handleEndDateChange={handleEndDateChange}
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
            handleEndConfirm={handleEndConfirm}
            handleEndCancel={handleEndCancel}
            getEndDate={getEndDate}
            weekdays={weekdays}
            months={months}
          />
        );

      case 4:
        return (
          <ScheduleTransactionStepConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isConfidential={isConfidential}
            previewImages={previewImages}
            allLabels={allLabels}
          />
        );
      default:
        return null;
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    categoryIds,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = (categoryIds || []).map(
      (c) => c.category_id ?? c.id,
    );
    setCategory(categoriesArray);
    setSelectedCategory(null);

    setTxnPayLoad({
      ...txnPayLoad,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels || [],
      selectedCategory: null,
      amountWords: "",
      amount: "",
      mergeCategory: null,
    });
    handleCloseModal();
  };

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name !== "amount" ||
      (!allowedValue(numericValue) && numericValue.length)
    ) {
      return;
    }
    const amountNumber = parseFloat(numericValue);
    const amountInWords = AmountToWords(amountNumber);
    const adjustedAmountWords =
      amountNumber > GlobalConfiguration?.lengthCheckZero &&
      amountNumber <= GlobalConfiguration?.lengthCheckOne
        ? amountInWords.replace("rupees", "rupee")
        : amountInWords;

    const settleType = amountNumber > 200000 ? "rtgs" : "neft";

    const paymentMethodChanged =
      (settleType === "neft" && isRtgs) || (settleType === "rtgs" && isNeft);

    if (paymentMethodChanged) {
      setSlideAnimation(true);

      setTimeout(
        () => setSlideAnimation(false),
        PaymentMethodAnimationConfiguration.slideDuration,
      );
    }
    setIsNeft(settleType === "neft");
    setIsRtgs(settleType === "rtgs");
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: numericValue,
      amountInWords: adjustedAmountWords,
      settleType,
    }));
  };

  const handleNeftClick = () => {
    if (Number(txnPayLoad?.amount) > RTGS_MIN_AMOUNT) {
      CommonToast({
        text: (
          <>
            Transaction amount should be less than <br /> INR 2 lakhs.
          </>
        ),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
  };

  const handleRtgsClick = () => {
    if (Number(txnPayLoad?.amount) <= RTGS_MIN_AMOUNT) {
      CommonToast({
        text: (
          <>
            Transaction amount should be more than <br /> INR 2 lakhs.
          </>
        ),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    return `${d.getDate()} ${d.toLocaleString("default", { month: "short" })}, ${d.getFullYear()}`;
  };

  const getEndDate = () => {
    if (!txnPayLoad?.transaction_start_date) return new Date();
    const base = new Date(txnPayLoad?.transaction_start_date);
    switch (txnPayLoad?.frequency) {
      case "Weekly":
        base.setDate(base.getDate() + 7);
        return base;
      case "Fortnightly":
        base.setDate(base.getDate() + 14);
        return base;
      case "Monthly":
        base.setMonth(base.getMonth() + 1);
        return base;
      case "Yearly":
        base.setFullYear(base.getFullYear() + 1);
        return base;
      case "Quarterly":
        base.setMonth(base.getMonth() + 3);
        return base;
      case "Half yearly":
        base.setMonth(base.getMonth() + 6);
        return base;
      default:
        base.setDate(base.getDate() + 1);
        return base;
    }
  };

  const handleConfirm = () => {
    const isToday =
      frequencyStartDate &&
      new Date().getDate() === new Date(frequencyStartDate).getDate() &&
      new Date().getMonth() === new Date(frequencyStartDate).getMonth() &&
      new Date().getFullYear() === new Date(frequencyStartDate).getFullYear();

    setSlotMappingData(
      isToday
        ? SLOT_DATA.filter(
            (da) => Number(da.value.split(":")[0]) > new Date().getHours(),
          )
        : SLOT_DATA,
    );

    setShowDatePicker(false);

    setTxnPayLoad((prev) => {
      const updatedPayload = {
        ...prev,
        transaction_start_date: handleDateformat(frequencyStartDate),
        slot: "",
      };
      if (prev?.frequency === "Once") {
        updatedPayload.transaction_end_date =
          handleDateformat(frequencyStartDate);
      }
      return updatedPayload;
    });
  };

  const handleEndConfirm = () => {
    setShowEndDatePicker(false);

    setTxnPayLoad((prev) => ({
      ...prev,
      transaction_end_date: handleDateformat(frequencyEndDate),
    }));
  };

  const handleCancel = () => {
    setShowDatePicker(false);
    setFrequencyStartDate(null);
    setFrequencyEndDate(null);
    setScheduleOccurrenceDates([]);

    setTxnPayLoad({
      ...txnPayLoad,
      transaction_start_date: null,
      transaction_end_date: null,
      occurrences: "",
    });
  };

  const handleEndCancel = () => {
    setShowEndDatePicker(false);
    setFrequencyStartDate(null);
    setFrequencyEndDate(null);
    setScheduleOccurrenceDates([]);

    setTxnPayLoad({
      ...txnPayLoad,
      transaction_start_date: null,
      transaction_end_date: null,
      occurrences: "",
    });
  };

  const handleDateChange = (date) => {
    setFrequencyStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setFrequencyEndDate(date);
  };

  const handleDateformat = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const handleFetchOccurence = async () => {
    const payloadObj = {
      paramsData: {
        frequency:
          txnPayLoad?.frequency === "Half yearly"
            ? "half_yearly"
            : (txnPayLoad?.frequency || "").toLowerCase(),
        transaction_start_date: handleDateformat(
          txnPayLoad?.transaction_start_date,
        ),
        transaction_end_date: handleDateformat(
          txnPayLoad?.transaction_end_date,
        ),
      },
    };

    const data = await dispatch(scheduledBeneficiaryOccurrences(payloadObj));

    setTxnPayLoad((prev) => ({
      ...prev,
      occurrences: data?.payload?.occurrences ?? "",
    }));

    setScheduleOccurrenceDates(data?.payload?.dates ?? []);
  };

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: false }));
  }, [dispatch]);

  useEffect(() => {
    if (txnPayLoad?.beneAccountId && !categories?.length) {
      dispatch(getAllCategories());
    }
  }, [txnPayLoad?.beneAccountId, categories, dispatch]);

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];
    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");
    const filledMandatoryFields = mergeCategory.filter((val) => {
      if (val?.mandatory !== "Y") return false;

      switch (val?.data_type) {
        case "multi_select_list":
          return Array.isArray(val.value) && val.value.length > 0;

        case "from_year_to_year": {
          const from = val?.value?.from;
          const to = val?.value?.to;

          const bothEmpty = from == null && to == null;
          const bothFilled = from != null && to != null;

          if (bothEmpty && val?.mandatory !== "Y") return true;
          return bothFilled;
        }

        case "month_year":
          return typeof val?.value === "string" && val.value !== "";

        case "date_range":
          return val?.value?.start_date && val?.value?.end_date;

        case "toggle":
          return val?.value === true;

        case "upload":
          return !!val?.value;

        default:
          return val?.value !== "" && val?.value !== undefined;
      }
    });

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    const isAmountValid = txnPayLoad?.amount > 0;

    const isRtgsSelected = txnPayLoad?.settleType === "rtgs";
    const isRtgsValid = !isRtgsSelected || txnPayLoad?.amount >= 200000;

    const isSettleTypeValid =
      txnPayLoad?.settleType &&
      !(
        (txnPayLoad?.settleType === "imps" && txnPayLoad?.amount > 200000) ||
        (txnPayLoad?.settleType === "rtgs" && txnPayLoad?.amount <= 200000) ||
        (txnPayLoad?.settleType === "neft" && txnPayLoad?.amount > 200000)
      );

    const isStepFourValid =
      !!txnPayLoad?.frequency &&
      !!txnPayLoad?.occurrences &&
      !!txnPayLoad?.slot &&
      !!txnPayLoad?.transaction_start_date &&
      !!txnPayLoad?.transaction_end_date;

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid =
          !!txnPayLoad?.beneAccountId &&
          !!txnPayLoad?.ownerId &&
          txnPayLoad?.scheduleName?.replace(/\s+/g, "").trim().length >=
            GlobalConfiguration?.lengthCheckFive &&
          /^.*$/.test(txnPayLoad?.scheduleName);
        break;

      case 1:
        isStepValid =
          !!txnPayLoad?.selectedCategory &&
          isMandatoryFieldsFilled &&
          (!isHyperlinkHave || isHyperLink);
        break;

      case 2:
        isStepValid = isAmountValid && isRtgsValid && isSettleTypeValid;
        break;

      case 3:
        isStepValid = isStepFourValid;
        break;

      case 4:
        isStepValid = true;
        break;

      default:
        isStepValid = false;
    }
    setIsNextButtonEnabled(isStepValid);
  }, [activeStep, txnPayLoad, hyperLink]);

  useEffect(() => {
    if (!additionalData) return;

    const storeData = txnPayLoad.selectedCategory?.configuration?.data?.map(
      (val) => {
        const dataValue = additionalData[val?.name];

        if (
          dataValue !== undefined &&
          (Array.isArray(dataValue)
            ? dataValue.length > GlobalConfiguration?.lengthCheckZero
            : dataValue !== "")
        ) {
          if (val?.data_type === "numeric") {
            return {
              ...val,
              value: String(dataValue),
            };
          }
          return { ...val, value: dataValue };
        }

        switch (val?.data_type) {
          case "multi_select_list":
            return { ...val, value: [] };

          case "toggle":
            return { ...val, value: false };

          case "hyperlink":
          case "upload":
            return { ...val, value: "" };

          default:
            return val?.mandatory !== "Y" ? { ...val, value: "" } : val;
        }
      },
    );

    setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
  }, [additionalData, txnPayLoad.selectedCategory]);

  useEffect(() => {
    const labelTxnRaw = sessionStorage.getItem("scheduleBeneficiaryTxnLabels");
    const accountTxnRaw = sessionStorage.getItem("beneficiaryAccountLabels");

    const txnLabels = labelTxnRaw ? JSON.parse(labelTxnRaw) : [];
    const accounLabels = accountTxnRaw ? JSON.parse(accountTxnRaw) : [];

    const initialLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerLabels || []),
      ...txnLabels,
      ...accounLabels,
    ];

    setLabels([...new Set(initialLabels)]);
  }, []);

  useEffect(() => {
    if (!txnPayLoad) return;

    const ownerLabels = txnPayLoad?.ownerLabels || [];
    const labels = txnPayLoad?.labels || [];

    const combined = [
      ...ownerLabels,
      ...labels.filter((label) => !ownerLabels.includes(label)),
    ];

    setSelectedLabelsCreate(combined);
  }, [txnPayLoad?.ownerLabels, txnPayLoad?.labels]);

  useEffect(() => {
    setFrequencyStartDate(
      parseToDateOrNull(txnPayLoad?.transaction_start_date),
    );
    setFrequencyEndDate(parseToDateOrNull(txnPayLoad?.transaction_end_date));
  }, [txnPayLoad?.transaction_start_date, txnPayLoad?.transaction_end_date]);

  useEffect(() => {
    const isToday =
      frequencyStartDate &&
      new Date().getDate() === new Date(frequencyStartDate).getDate() &&
      new Date().getMonth() === new Date(frequencyStartDate).getMonth() &&
      new Date().getFullYear() === new Date(frequencyStartDate).getFullYear();

    setSlotMappingData(
      isToday
        ? SLOT_DATA.filter(
            (da) => Number(da.value.split(":")[0]) > new Date().getHours(),
          )
        : SLOT_DATA,
    );

    if (
      txnPayLoad?.transaction_start_date &&
      txnPayLoad?.transaction_end_date &&
      txnPayLoad?.frequency
    ) {
      handleFetchOccurence();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    txnPayLoad?.transaction_start_date,
    txnPayLoad?.transaction_end_date,
    txnPayLoad?.frequency,
  ]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
      if (
        slotdropdownRef.current &&
        !slotdropdownRef.current.contains(e.target)
      )
        setSlotDropdownOpen(false);
      if (dateRef.current && !dateRef.current.contains(e.target))
        setShowDatePicker(false);
      if (endDateRef.current && !endDateRef.current.contains(e.target))
        setShowEndDatePicker(false);
    }

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (frequencyStartDate) handleConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frequencyStartDate]);

  useEffect(() => {
    if (frequencyEndDate) handleEndConfirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frequencyEndDate]);

  return (
    <>
      {showConfirmLeavePopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-top-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-lg"
            subtext={globalText?.EXIT_CURRENT_FLOW_NOTE}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={() => setShowConfirmLeavePopup(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={() => {
              setShowConfirmLeavePopup(false);
              navigate(-1);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={showLabelModal}
            setPayload={setTxnPayLoad}
            txnPayLoad={txnPayLoad}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={(x) => setSelectedLabelsCreate(x)}
            labelActionDispatchedRef={labelActionDispatchedRef}
            loading={loading}
            setLoading={setLoading}
            type="create"
          />
        </div>
      )}

      {openOccurrencesModal && (
        <div className="z-z-index-max">
          <ScheduleTxnOccurrencesPopup
            closeCallback={() => setOpenOccurrencesModal(false)}
            occurrences={scheduleOccurrenceDates}
          />
        </div>
      )}

      <div className="h-screen flex-col flex overflow-hidden">
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
        <div className="fixed Qsmd:relative left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto Qsmd:bg-transparent shrink-0 Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-moble-height">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
        <>
          {!openOccurrencesModal && (
            <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
              <TopNavComponent
                topNavHeader={globalText?.CREATE_SCHEDULE_TRANSACTION}
                topNavSubText={steps[activeStep] || ""}
                isFormattingNotRequired
              />
            </div>
          )}
        </>
        <div
          className={`flex flex-col h-height-full items-center relative w-width-full flex-1 overflow-y-auto overflow-x-hidden ${activeStep === 1 ? "mb-[var(--stepper-moble-height)] Qmd:mb-margin-base" : ""}`}
          style={{ scrollbarWidth: "none" }}
        >
          <div className="max-w-screen-Qlg mx-auto flex flex-col w-width-full">
            <div className="w-width-full">
              <div className="h-navbar-height Qsmd:hidden block"></div>
            </div>
            <div
              className={`w-width-full ${
                activeStep === 0 && direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClassS
              }`}
            >
              {renderBillerForms()}
            </div>
          </div>
        </div>
        {activeStep !== 1 && (
          <div className="h-stepper-moble-height w-width-full Qsmd:hidden block"></div>
        )}
      </div>
    </>
  );
};

export default ScheduleBeneficiaryTransactionCreate;
